<div class="card mt-lg-4 bg-tertiary">
  <div class="card-content px-3 d-flex">
    <h5 class=" mb-0 mb-lg-2 font-weight-bold text-white text-capitalize">
      {{ 'voucher.title' | translate }}
    </h5>
    <div class="insert-code-container">
      <span class="input-group">
        <input
          type="text"
          [(ngModel)]="voucherCode"
          placeholder="INSERT CODE HERE"
          onfocus="this.placeholder = ''"
          class="insert-code form-control text-center border-0 px-5 px-lg-0 bg-black"
          (keyup.enter)="redeemVoucher()"
        />
        <div class="input-group-append">
          <button
            class="check-code btn btn-primary icon text-white font-weight-bold material-icons py-0 px-2"
            type="button"
            (click)="redeemVoucher()"
            [disabled]="disableButton"
          >
            arrow_forward_ios
          </button>
        </div>
      </span>
      <div class="text-center">
        <fgbcl-errors></fgbcl-errors>
      </div>

      <div class="result text-center" *ngIf="redemptionResult">
        <div
          class="font-size-12 mt-1 text-success"
          [ngClass]="redemptionResult === sucessfulRedemption ? 'text-success' : 'text-white'"
        >
          {{ redemptionResult }}
        </div>
      </div>
    </div>
  </div>
</div>
